module.exports = __webpack_public_path__ + "img/infinity_8_regular.bb9a543d.png";